let quickFollowUpCallFromBFileActionTemp = false;
let duplicateCustomerCallback = null;
let showSendingBFileModalState = true;
let adminCsvDuplicateData = null;
let duplicateDataCallback = null;
let setDncCustomerCallback = null;
let reviewSchedulerListCallback = null;
let tempHoldAgencyData = null;

export default {
  setQuickFollowUpCallFromBFileActionTemp(value) {
    quickFollowUpCallFromBFileActionTemp = value;
  },

  isQuickFollowUpCallFromBFileActionTemp() {
    return quickFollowUpCallFromBFileActionTemp;
  },

  setDuplicateCustomerCallback(callback) {
    duplicateCustomerCallback = callback;
  },

  callDuplicateCustomerCallback() {
    return duplicateCustomerCallback;
  },

  setSendingBFileModalState(value) {
    showSendingBFileModalState = value;
  },

  isShowSendingBFileModalState() {
    return showSendingBFileModalState;
  },

  setAdminCsvDuplicateData(data) {
    adminCsvDuplicateData = data;
  },

  getAdminCsvDuplicateData() {
    return adminCsvDuplicateData;
  },

  setDuplicateDataCallback(data) {
    duplicateDataCallback = data;
  },

  getDuplicateDataCallback() {
    return duplicateDataCallback;
  },

  setDncCustomerCallback(data) {
    setDncCustomerCallback = data;
  },

  getDncCustomerCallback() {
    return setDncCustomerCallback;
  },

  setReviewSchedulerListCallback(data) {
    reviewSchedulerListCallback = data;
  },

  getReviewSchedulerListCallback() {
    return reviewSchedulerListCallback;
  },

  setTempHoldAgencyData(data) {
    tempHoldAgencyData = data;
  },

  getTempHoldAgencyData() {
    return tempHoldAgencyData;
  }
};



// WEBPACK FOOTER //
// ./src/utils/DataHandler.js